export var PartnerTransferSection;
(function (PartnerTransferSection) {
    PartnerTransferSection["PartnerTransfer"] = "PartnerTransfer";
    PartnerTransferSection["Investments"] = "Investments";
    PartnerTransferSection["IncomeAndExpenses"] = "IncomeAndExpenses";
    PartnerTransferSection["Realisations"] = "Realisations";
    PartnerTransferSection["Fees"] = "Fees";
    PartnerTransferSection["CapitalActions"] = "CapitalActions";
    PartnerTransferSection["Summary"] = "Summary";
})(PartnerTransferSection || (PartnerTransferSection = {}));
export var PartnerTransferTypes;
(function (PartnerTransferTypes) {
    PartnerTransferTypes["PartnerTransfer"] = "partnerTransfer";
})(PartnerTransferTypes || (PartnerTransferTypes = {}));
export var ReallocationEventType;
(function (ReallocationEventType) {
    ReallocationEventType["PARTNER_TRANSFER"] = "PARTNER_TRANSFER";
    ReallocationEventType["EQUALISATION"] = "EQUALISATION";
})(ReallocationEventType || (ReallocationEventType = {}));
//# sourceMappingURL=index.js.map